import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { SUB_TYPE, USER_TYPE } from 'src/app/core/Constants/static';
import { TransactionListByClient } from 'src/app/core/Models/interfaces/responseData';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { PrescriptionService } from 'src/app/features/prescription/prescription.service';
import { ToasterService } from 'src/app/shared/services/toaster.service';
import { CustomValidation } from 'src/app/shared/validators/customValidators';
import { AuthorizationsService } from '../../services/authorizations.service';
import { UtilityService } from 'src/app/core/Services/utility.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CommonList } from 'src/app/core/Models/interfaces/commonList';
import { Pagination } from 'src/app/core/Models/interfaces/pagination';

@Component({
    selector: 'app-authorizations-list',
    templateUrl: './authorizations-list.component.html',
    styleUrls: ['./authorizations-list.component.css']
})
export class AuthorizationsListComponent implements OnInit {

    @ViewChildren('focusedElement') focusedElement!: QueryList<ElementRef>;
    @ViewChild('advancedFilter') advancedFilter!: ElementRef;

    private sortParams!: string;
    private page_limit: number = 10;
    public showPrescriptionDetails: boolean = false;
    public transactionListByClient: TransactionListByClient[] = [];
    public authorizationFilterForm!: FormGroup;
    public exportVar: number = 0;
    public totalCount!: number;
    public page_no: number = 1;
    public batchId!: number;
    public requestBatchId!: string;
    public subTypes = SUB_TYPE
    public subTypeEvm = environment?.subscriberType ? environment?.subscriberType : this.subTypes.both;
    public showNavigation: boolean = false;
    public user?: UserDetails;
    public DynamicTabs: CommonList[] = []
    public columnSort: Record<string, { sortType: string, clicked?: boolean }> = {
        requestId: {
            sortType: 'ascending',
        },
        senderId: {
            sortType: 'ascending',
        },
        receiverId: {
            sortType: 'ascending',
        },
        transactionDate: {
            sortType: 'ascending',
        },
        payerId: {
            sortType: 'ascending',
        },
        memberId: {
            sortType: 'ascending',
        },
        eHealthId: {
            sortType: 'ascending',
        },
        documentID: {
            sortType: 'ascending',
        },
        visitedOn: {
            sortType: 'ascending',
        },
        providerId: {
            sortType: 'ascending',
        },
    };
    public statusArray: { id: string, name: string }[] = [
        {
            id: '0',
            name: 'Rejected'
        },
        {
            id: '2',
            name: 'Partially Approved'
        },
        {
            id: '3',
            name: 'Cancelled'
        }
    ]
    public showAdvancedFilter: boolean = false;
    public isInsideAdvacedContainer: boolean = false;
    public advFilter: boolean = false;
    public activeTab: number = 1;
    constructor(
        private prescriptionService: PrescriptionService,
        private toasterandLoader: ToasterService,
        private userService: UserService,
        private authorizationService: AuthorizationsService,
        private utility: UtilityService,
        private router: Router
    ) {
        this.user = userService.getUserInfo()?.userDetails;
        this.authorizationFilterForm = new FormGroup({
            requestId: new FormControl(null),
            senderId: new FormControl(null),
            receiverId: new FormControl(null),
            payerId: new FormControl(null),
            memberId: new FormControl(null),
            documentID: new FormControl(null),
            status: new FormControl(null),
            healthId: new FormControl(null),
            prescriptionId: new FormControl(null),
            providerId: new FormControl(null),
            isOverriden: new FormControl(null),

        }, CustomValidation.formNotNull);
    }


    @HostListener('document:click', ['$event'])
    clickOutSideAdvancedContainer(event: Event) {
        if (!this.isInsideAdvacedContainer && !this.advancedFilter?.nativeElement.contains(event.target as Node)) {
            this.showAdvancedFilter = false;
        }
        this.isInsideAdvacedContainer = false;
    }

    ngOnInit(): void {
        if(this.subTypeEvm !== this.subTypes.payer && this.checkPermission('getGeneralSettingsDynamicTab')){
            this.getAllTabs();
        }
        if (this.checkPermission('getTransactionClientPreApproval') || this.checkPermission('getTransactionPayerPreApproval') || this.checkPermission('getTransactionProviderPreApproval')) {
            this.activeTab = 1;
        } else if (this.checkPermission('getTransactionClientLabPreApproval')) {
            this.activeTab = 2;
        } else {
            this.activeTab = 3;
        }
        if(this.authorizationService.activeTab > 0){
            this.activeTab = this.authorizationService.activeTab
        }
    }

    public getTransactionListByPayer(filterPayload: Record<string, string | number | null>): void {
        this.authorizationService.getPreApprovalListByPayer(filterPayload, <number>this.user?.payerId).subscribe({
            next: (list) => {
                this.transactionListByClient = list.data.data;
                if (!this.transactionListByClient.length) this.showNavigation = true;
                this.totalCount = list?.data?.total;
                this.toasterandLoader.isLoaderEnable(false);
            }, error: (error) => {
                this.toasterandLoader.isLoaderEnable(false);
            }
        });
    }

    private getTransactionListByClient(filterPayload: Record<string, string | number | null>): void {
        this.toasterandLoader.isLoaderEnable(true);
        this.authorizationService.getPreApprovalList(filterPayload, <number>this.user?.clientId).subscribe({
            next: (list) => {
                this.transactionListByClient = list.data.data;
                this.totalCount = list?.data?.total;
                if (!this.transactionListByClient.length) this.showNavigation = true;
                this.toasterandLoader.isLoaderEnable(false);
            },
            error: (error) => {
                this.toasterandLoader.isLoaderEnable(false);
            }
        });
    }

    private getTransactionListByCommon(filterPayload: Record<string, string | number | null>): void {
        this.toasterandLoader.isLoaderEnable(true);
        this.authorizationService.getPreApprovalListCommon(filterPayload, <number>this.user?.clientId).subscribe({
            next: (list) => {
                this.transactionListByClient = list.data.data;
                this.totalCount = list?.data?.total;
                if (!this.transactionListByClient.length) this.showNavigation = true;
                this.toasterandLoader.isLoaderEnable(false);
            },
            error: (error) => {
                this.toasterandLoader.isLoaderEnable(false);
            }
        });
    }

    private getTransactionListByProvider(filterPayload: Record<string, string | number | null>): void {
        this.toasterandLoader.isLoaderEnable(true);
        this.authorizationService.getPreApprovalListByProvider(filterPayload, <number>this.user?.providerId).subscribe({
            next: (list) => {
                this.transactionListByClient = list.data.data;
                if (!this.transactionListByClient.length) this.showNavigation = true;
                this.totalCount = list?.data?.total;
                this.toasterandLoader.isLoaderEnable(false);
            },
            error: (error) => {
                this.toasterandLoader.isLoaderEnable(false);
            }
        });
    }

    private isScrollIntoViewNeeded(): void {
        setTimeout(() => {
            this.focusedElement.last?.nativeElement.scrollIntoView();
        }, 100);
    }

    public resetFilter(): void {
        this.authorizationFilterForm.reset();
        this.page_limit = 10;
        this.page_no = 1;
        this.totalCount = 1;
        this.showNavigation = false;
        this.showAdvancedFilter = false;
        this.isInsideAdvacedContainer = false;
        this.userTypeListing();
    }

    public currentPageDetail(event: Pagination):void{
        if (event) {
            this.page_no = event.button_no;
            this.page_limit = event.item_per_page;
        }
        this.isScrollIntoViewNeeded();
        this.userTypeListing();
    }

    public userTypeListing(): void {
        let filterPayload = {
            per_page: this.page_limit,
            page: this.page_no,
            sort: this.sortParams,
            requestId: this.authorizationFilterForm?.value?.requestId || '',
            senderId: this.authorizationFilterForm?.value?.senderId || '',
            receiverId: this.authorizationFilterForm?.value?.receiverId || '',
            payerId: this.authorizationFilterForm?.value?.payerId || '',
            memberId: this.authorizationFilterForm?.value?.memberId || '',
            facilityId: this.authorizationFilterForm?.value?.documentID || '',
            healthId: this.authorizationFilterForm?.value?.healthId || '',
            prescriptionId: this.authorizationFilterForm?.value?.prescriptionId || '',
            providerId: this.authorizationFilterForm?.value?.providerId || '',
            approvalStatus: this.authorizationFilterForm?.value?.status || '',
            isOverriden: this.authorizationFilterForm?.value?.isOverriden ? '1' : '',
        }

        this.getTransactionListByCommon(filterPayload);
        // if (this.user?.userType === USER_TYPE.payer && this.checkPermission('getTransactionPayerPreApproval')) {
        //     this.getTransactionListByPayer(filterPayload);
        // } else if (this.user?.userType === USER_TYPE.provider && this.checkPermission('getTransactionProviderPreApproval')) {
        //     this.getTransactionListByProvider(filterPayload);
        // } else if (this.user?.userType === USER_TYPE.system && this.checkPermission('getTransactionClientPreApproval')) {
        //     this.getTransactionListByClient(filterPayload);
        // }
        this.showAdvancedFilter = false;
        this.isInsideAdvacedContainer = false;
    }

    public sortColumn(colName: string): void {
        for (const key in this.columnSort) {
            if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
                const element = this.columnSort[key];
                if (key == colName) {
                    this.columnSort[colName].clicked = true;
                    this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
                    this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
                    this.page_no = 1;
                    this.userTypeListing();
                } else {
                    this.columnSort[key].sortType = 'ascending';
                }
            }
        }
    }

    public switchTab(tab: number): void {
        if (tab === 1 && this.activeTab !== 1) {
            this.authorizationFilterForm.reset();
        }
        this.exportVar = 0;
        this.authorizationService.activeTab = this.activeTab = tab;
    }

    public selectedValue(event: string | null, formElem: string): void {
        if (!event) {
            this.authorizationFilterForm.controls[formElem].patchValue(null);
        }
        this.authorizationFilterForm.controls[formElem].patchValue(event);
    }

    public checkPermission(perName: string): boolean {
        return this.userService.getPermissions(perName);
    }

    public onAdvancedClick(event: MouseEvent): void {
        event?.stopPropagation();
        this.showAdvancedFilter = !this.showAdvancedFilter;
    }

    public onInsideAdvanceContainerClick(): void {
        this.isInsideAdvacedContainer = true;
    }

    public closeAdvanceFilter(controlName: string): void {
        this.authorizationFilterForm.controls[controlName].reset();
        this.isScrollIntoViewNeeded();
        this.userTypeListing();
    }

    public showRadLabDetails(event: any): void {
        event.requestId = event.batchId
        this.navigateToView(event)

    }

    public exportList(): void {
        if (this.activeTab === 1) {
            let filterPayload = {
                sort: this.sortParams,
                requestId: this.authorizationFilterForm?.value?.requestId || '',
                senderId: this.authorizationFilterForm?.value?.senderId || '',
                receiverId: this.authorizationFilterForm?.value?.receiverId || '',
                payerId: this.authorizationFilterForm?.value?.payerId || '',
                memberId: this.authorizationFilterForm?.value?.memberId || '',
                facilityId: this.authorizationFilterForm?.value?.documentID || '',
                healthId: this.authorizationFilterForm?.value?.healthId || '',
                prescriptionId: this.authorizationFilterForm?.value?.prescriptionId || '',
                providerId: this.authorizationFilterForm?.value?.providerId || '',
                approvalStatus: this.authorizationFilterForm?.value?.status || '',
                iProviderType: null,
                iIsApprovalRequired: 1
            }
            this.prescriptionService.exportList(filterPayload)
                .pipe().subscribe({
                    next: (response: any) => {
                        this.utility.download(response, this.utility.downloadTypes.excel)
                    },
                    error: (error) => {
                        this.toasterandLoader.alert.toast({
                            title: 'Error',
                            type: 'error',
                            message: error.message
                        });
                    }
                });
        } else {
            this.exportVar++
        }
    }

    public navigateToView(item: TransactionListByClient): void {
        let url = this.router.url;
        if (url && item.requestId) {
            if (url.includes('authorizations/authorizationslist')) {
                this.router.navigate(['authorizations', 'detail-view', item.requestId]);
            }
        }

    }

    private getAllTabs() : void {
        this.toasterandLoader.isLoaderEnable(true);
        this.prescriptionService.getAllTabs({generatorType:'AUTHORIZATION'}).subscribe({
            next: (response: any) => {
                this.DynamicTabs = response.data
                this.toasterandLoader.isLoaderEnable(false);
                if(this.activeTab > this.DynamicTabs.length+1){
                    this.activeTab = 1;
                }
            },
            error: (error) => {
                this.toasterandLoader.isLoaderEnable(false);
                this.toasterandLoader.alert.toast({
                    title: 'Error',
                    type: 'error',
                    message: error.message
                });
            }
        });
    }


}
